import { UserTypes } from '../constants';

const OS_TYPES = new Set([
    UserTypes.OS_USER,
    UserTypes.OS_USER_WITHOUT_PUBLIC_KEY,
    UserTypes.OS_USER_WITHOUT_PRIVATE_KEY,
    UserTypes.OS_USER_WITHOUT_OLD_PRIVATE_KEY,
]);

const DRUGSTORE_TYPES = new Set([
    UserTypes.DRUGSTORE,
    UserTypes.DRUGSTORE_WITHOUT_PUBLIC_KEY,
    UserTypes.DRUGSTORE_WITHOUT_PRIVATE_KEY,
    UserTypes.DRUGSTORE_WITHOUT_OLD_PRIVATE_KEY,
]);

const ROCHE_TYPES = new Set([UserTypes.ROCHE_USER, UserTypes.ROCHE_USER_WITHOUT_PRIVATE_KEY]);

/**
 * Maps Redux profile user.type to backend wallet payment type_from (O / D / R).
 * Returns null for types that cannot initiate wallet sends.
 */
export function mapUserTypeToTypeFrom(userType) {
    if (OS_TYPES.has(userType)) return 'O';
    if (DRUGSTORE_TYPES.has(userType)) return 'D';
    if (ROCHE_TYPES.has(userType)) return 'R';
    return null;
}
